import React from 'react';

// Logo variations for Koctech Klima
// These are temporary placeholder logos until you get professional designs

export const Logo1 = ({ className = "w-12 h-12" }) => (
  // Circular airflow design
  <div className={`${className} relative flex items-center justify-center`}>
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#14b8a6', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#0d9488', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      {/* Outer circle */}
      <circle cx="50" cy="50" r="45" fill="none" stroke="url(#grad1)" strokeWidth="3"/>
      {/* Airflow swirls */}
      <path d="M 50 20 Q 70 30, 70 50" fill="none" stroke="url(#grad1)" strokeWidth="4" strokeLinecap="round"/>
      <path d="M 80 50 Q 70 70, 50 70" fill="none" stroke="url(#grad1)" strokeWidth="4" strokeLinecap="round"/>
      <path d="M 50 80 Q 30 70, 30 50" fill="none" stroke="url(#grad1)" strokeWidth="4" strokeLinecap="round"/>
      <path d="M 20 50 Q 30 30, 50 30" fill="none" stroke="url(#grad1)" strokeWidth="4" strokeLinecap="round"/>
      {/* Center dot */}
      <circle cx="50" cy="50" r="8" fill="url(#grad1)"/>
    </svg>
  </div>
);

export const Logo2 = ({ className = "w-12 h-12" }) => (
  // Leaf + airflow hybrid
  <div className={`${className} relative flex items-center justify-center`}>
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <defs>
        <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#14b8a6', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#0d9488', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      {/* Leaf shape */}
      <path d="M 50 10 Q 80 30, 70 60 Q 65 80, 50 90 Q 35 80, 30 60 Q 20 30, 50 10" 
            fill="url(#grad2)" opacity="0.3"/>
      {/* Airflow lines */}
      <path d="M 50 30 L 50 70" stroke="url(#grad2)" strokeWidth="3" strokeLinecap="round"/>
      <path d="M 40 40 Q 50 45, 60 40" stroke="url(#grad2)" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
      <path d="M 40 55 Q 50 60, 60 55" stroke="url(#grad2)" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
    </svg>
  </div>
);

export const Logo3 = ({ className = "w-12 h-12" }) => (
  // Snowflake + breeze
  <div className={`${className} relative flex items-center justify-center`}>
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <defs>
        <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#14b8a6', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#0d9488', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      {/* Snowflake arms */}
      <line x1="50" y1="15" x2="50" y2="85" stroke="url(#grad3)" strokeWidth="3" strokeLinecap="round"/>
      <line x1="15" y1="50" x2="85" y2="50" stroke="url(#grad3)" strokeWidth="3" strokeLinecap="round"/>
      <line x1="25" y1="25" x2="75" y2="75" stroke="url(#grad3)" strokeWidth="3" strokeLinecap="round"/>
      <line x1="75" y1="25" x2="25" y2="75" stroke="url(#grad3)" strokeWidth="3" strokeLinecap="round"/>
      {/* Decorative ends */}
      <circle cx="50" cy="15" r="4" fill="url(#grad3)"/>
      <circle cx="50" cy="85" r="4" fill="url(#grad3)"/>
      <circle cx="15" cy="50" r="4" fill="url(#grad3)"/>
      <circle cx="85" cy="50" r="4" fill="url(#grad3)"/>
      {/* Center */}
      <circle cx="50" cy="50" r="8" fill="url(#grad3)"/>
    </svg>
  </div>
);

export const Logo4 = ({ className = "w-12 h-12" }) => (
  // Minimalist AC unit
  <div className={`${className} relative flex items-center justify-center`}>
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <defs>
        <linearGradient id="grad4" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#14b8a6', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#0d9488', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      {/* AC unit body */}
      <rect x="20" y="30" width="60" height="25" rx="3" fill="url(#grad4)"/>
      {/* Airflow vents */}
      <line x1="30" y1="38" x2="30" y2="47" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <line x1="40" y1="38" x2="40" y2="47" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <line x1="50" y1="38" x2="50" y2="47" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <line x1="60" y1="38" x2="60" y2="47" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <line x1="70" y1="38" x2="70" y2="47" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      {/* Cool air waves */}
      <path d="M 30 60 Q 35 65, 40 60" stroke="url(#grad4)" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <path d="M 45 65 Q 50 70, 55 65" stroke="url(#grad4)" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <path d="M 60 70 Q 65 75, 70 70" stroke="url(#grad4)" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
    </svg>
  </div>
);

export const Logo5 = ({ className = "w-12 h-12" }) => (
  // Bold K monogram
  <div className={`${className} relative flex items-center justify-center bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg`}>
    <svg viewBox="0 0 100 100" className="w-full h-full">
      {/* Modern K letter */}
      <path d="M 25 20 L 25 80" stroke="white" strokeWidth="8" strokeLinecap="round"/>
      <path d="M 25 50 L 70 20" stroke="white" strokeWidth="8" strokeLinecap="round"/>
      <path d="M 25 50 L 70 80" stroke="white" strokeWidth="8" strokeLinecap="round"/>
      {/* Cooling element - small breeze lines */}
      <path d="M 75 35 L 85 30" stroke="white" strokeWidth="3" strokeLinecap="round" opacity="0.7"/>
      <path d="M 75 50 L 85 50" stroke="white" strokeWidth="3" strokeLinecap="round" opacity="0.7"/>
      <path d="M 75 65 L 85 70" stroke="white" strokeWidth="3" strokeLinecap="round" opacity="0.7"/>
    </svg>
  </div>
);

export const Logo6 = ({ className = "w-12 h-12" }) => (
  // Wind turbine / propeller style
  <div className={`${className} relative flex items-center justify-center`}>
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <defs>
        <linearGradient id="grad6" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#14b8a6', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#0d9488', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      {/* Three propeller blades */}
      <ellipse cx="50" cy="25" rx="15" ry="20" fill="url(#grad6)" opacity="0.8"/>
      <ellipse cx="71" cy="63" rx="15" ry="20" fill="url(#grad6)" opacity="0.8" transform="rotate(120 50 50)"/>
      <ellipse cx="29" cy="63" rx="15" ry="20" fill="url(#grad6)" opacity="0.8" transform="rotate(240 50 50)"/>
      {/* Center hub */}
      <circle cx="50" cy="50" r="10" fill="url(#grad6)"/>
    </svg>
  </div>
);

export const Logo7 = ({ className = "w-12 h-12" }) => (
  // Modern geometric shield with cooling waves
  <div className={`${className} relative flex items-center justify-center`}>
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <defs>
        <linearGradient id="grad7" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#14b8a6', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#0d9488', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      {/* Shield shape */}
      <path d="M 50 10 L 80 30 L 80 60 Q 80 85, 50 90 Q 20 85, 20 60 L 20 30 Z" 
            fill="url(#grad7)" opacity="0.2" stroke="url(#grad7)" strokeWidth="2"/>
      {/* Cooling waves inside */}
      <path d="M 35 40 Q 50 35, 65 40" fill="none" stroke="url(#grad7)" strokeWidth="3" strokeLinecap="round"/>
      <path d="M 35 50 Q 50 45, 65 50" fill="none" stroke="url(#grad7)" strokeWidth="3" strokeLinecap="round"/>
      <path d="M 35 60 Q 50 55, 65 60" fill="none" stroke="url(#grad7)" strokeWidth="3" strokeLinecap="round"/>
    </svg>
  </div>
);

// Default export with text
const LogoWithText = ({ variant = 1, showText = true, className = "" }) => {
  const LogoComponent = {
    1: Logo1,
    2: Logo2,
    3: Logo3,
    4: Logo4,
    5: Logo5,
    6: Logo6,
    7: Logo7
  }[variant] || Logo1;

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <LogoComponent className="w-10 h-10" />
      {showText && (
        <div>
          <span className="font-bold text-lg text-gray-900">Koctech</span>
          <span className="block text-xs text-teal-600 font-medium">İklimlendirme</span>
        </div>
      )}
    </div>
  );
};

export default LogoWithText;
